import type { ITheme } from '@xterm/xterm';

const DARK_TERMINAL_THEME: ITheme = {
  background: '#141715',
  foreground: '#f5f5f5',
  cursor: '#f5f5f5',
  selectionBackground: '#5a5a5a',
  black: '#141715',
  red: '#ff6b6b',
  green: '#4cd964',
  yellow: '#ffcc00',
  blue: '#54a0ff',
  magenta: '#ff6b9d',
  cyan: '#48dbfb',
  white: '#f5f5f5',
  brightBlack: '#8e8e93',
  brightRed: '#ff8a80',
  brightGreen: '#69f0ae',
  brightYellow: '#ffd740',
  brightBlue: '#82b1ff',
  brightMagenta: '#ff80ab',
  brightCyan: '#84ffff',
  brightWhite: '#ffffff',
};

const LIGHT_TERMINAL_THEME: ITheme = {
  background: '#FDFCFC',
  foreground: '#1e1e1e',
  cursor: '#1e1e1e',
  selectionBackground: '#b4d8fd',
  black: '#1e1e1e',
  red: '#c41a16',
  green: '#007400',
  yellow: '#826b28',
  blue: '#0000ff',
  magenta: '#a90d91',
  cyan: '#318495',
  white: '#8e8e93',
  brightBlack: '#8e8e93',
  brightRed: '#eb4034',
  brightGreen: '#00a800',
  brightYellow: '#a89c14',
  brightBlue: '#0451a5',
  brightMagenta: '#bc05bc',
  brightCyan: '#3971ed',
  brightWhite: '#ffffff',
};

export const TERMINAL_FONT_FAMILY =
  '"MesloLGS NF", "JetBrainsMono Nerd Font", "Hack Nerd Font", "FiraCode Nerd Font", "SF Mono", Menlo, Monaco, "Courier New", monospace';

export function getTerminalTheme({ isDark }: { isDark: boolean }): ITheme {
  return isDark ? DARK_TERMINAL_THEME : LIGHT_TERMINAL_THEME;
}
